var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('LogCrowJumbotron'),(_vm.logs.length > 0)?_c('LogCards',{attrs:{"logs":_vm.logs}}):_vm._e(),(_vm.logs.length === 0)?_c('LatestLog'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }